var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-links"},[(!_vm.special)?_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'position-languages',
      query: { position_id: _vm.position_id, company_id: _vm.company_id, position_status: _vm.position_status }
    }}},[_c('p',[_vm._v("Languages")])]):_vm._e(),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'position-skills',
      query: { position_id: _vm.position_id, company_id: _vm.company_id, position_status: _vm.position_status }
    }}},[_c('p',[_vm._v("Skills")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'position-educations',
      query: { position_id: _vm.position_id, company_id: _vm.company_id, position_status: _vm.position_status }
    }}},[_c('p',[_vm._v("Educations")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'position-texts',
      query: { position_id: _vm.position_id, company_id: _vm.company_id, position_status: _vm.position_status }
    }}},[_c('p',[_vm._v("Texts")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'position-locations',
      query: { position_id: _vm.position_id, company_id: _vm.company_id, position_status: _vm.position_status }
    }}},[_c('p',[_vm._v("Locations")])]),_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{ name: 'position-questions', query: { position_id: _vm.position_id, company_id: _vm.company_id, position_status: _vm.position_status } }}},[_c('p',[_vm._v("Questions")])]),(!_vm.special)?_c('router-link',{staticClass:"button is-hovered is-outlined",attrs:{"target":"_blank","to":{
      name: 'position-offers',
      query: {
        position_id: _vm.position_id,
        company_id: _vm.company_id,
        position_status: _vm.position_status,
        statuses: 'awaiting_company,system_strong',
        sort: '-sent_at'
      }
    }}},[_c('p',[_vm._v("Offers")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }